// Loading overlay with spinner

interface LoadingOverlayProps {
  message?: string
}

export function LoadingOverlay({ message }: LoadingOverlayProps) {
  return (
    <div id="loading-overlay" className="loading-overlay active">
      <div className="spinner"></div>
      <div className="loading-text">Hold Tight</div>
      <div className="loading-subheader">{message || 'Thanks for your patience'}</div>
    </div>
  )
}
